import React, {useState, useEffect} from "react";
import axios from 'axios';
import "./DashboardHomePage.css";
import {jwtDecode} from "jwt-decode";
import {Link} from "react-router-dom";
import {TiFlowSwitch} from "react-icons/ti";
import {IoFlameSharp, IoHammerSharp, IoNotifications, IoTimer} from "react-icons/io5";
import {FaFileSignature, FaHistory} from "react-icons/fa";
import {AiOutlineHourglass} from "react-icons/ai";
import {VscFolderActive, VscGistSecret, VscLayersActive} from "react-icons/vsc";
import CustomLoader from "../../../components/ConfirmationModal/CustomLoader";
import {MdCheckCircle, MdSdCardAlert} from "react-icons/md";
import CaseStatus from "../../../enums/CaseStatus";
import Topbar from "../sidebar/Topbar";
import {HiDocumentSearch} from "react-icons/hi";
import {RiPassExpiredLine} from "react-icons/ri";


const createRequestBody = (pageSize, page) => ({
    pageSize,
    page,
    permitTypeId: 0,
    filter: [],
    sort: [],
    activeUserId: "",
    caseUserUsersIds: [],
    caseRequesterIds: [],
    pertmiTypeIdList: []
});

function DashboardHomePage() {
    const [page] = useState(0);
    const [pageSize] = useState(0);
    const [loading, setLoading] = useState(false);
    const [axalishetyobinebaCount, setAxaliShetyobinebaCount] = useState(0);
    const [chemiMimdinareGanacxadebiCount, setChemiMimdinareGanacxadebiCount] = useState(0);
    const [mimdinareAdministraciuliWarmoebaCount, setMimdinareAdministraciuliWarmoebaCount] = useState(0);
    const [secretCases, setSecretCases] = useState(0);
    const [vadagadacilebuliCount, setVadagadacilebuliCount] = useState(0);
    const [istoriaCount, setIstoriaCount] = useState(0);
    const [declinedCasesCount, setDeclinedCasesCount] = useState(0);
    const [dasrulebuliAdministraciuliWarmoebaCount, setDasrulebuliAdministraciuliWarmoebaCount] = useState(0);
    const [isTermOfPermissionAndConditionCount, setIsTermOfPermissionAndConditionCount] = useState(0);
    const [permitDocCount, setPermitDocCount] = useState(0);
    const [expFile, setExpFile] = useState(0);
    const [userNewCaseCount, setUserNewCaseCount] = useState(0);
    const [userCasesCurrent, setUserCasesCurrent] = useState(0);
    const [userFinishedCases, setUserFinishedCases] = useState(0);
    const [lastActiveUserCases, setLastActiveUserCases] = useState(0);
    const [docsToSign, setDocsToSign] = useState(0);
    const [waitingToSign, setWaitingToSign] = useState(0);
    const [role, setRole] = useState(null);
    const [userId, setUserId] = useState(null);
    const [userDepartment, setUserDepartment] = useState(null);
    const token = localStorage.getItem('jwtToken');
    const isMobile = window.innerWidth < 768;
    const [explotionList, setExplotionList] = useState([]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`
                );
                const { data } = response.data;

                const collectIdsWithOrderDepartment = (nodes, targetDepartment) => {
                    const result = [];
                    const traverse = (node) => {
                        if (node.orderDepartment === targetDepartment) {
                            result.push(node.id);
                        }
                        if (node.childrenPermitTypes && node.childrenPermitTypes.length > 0) {
                            node.childrenPermitTypes.forEach(traverse);
                        }
                    };
                    nodes.forEach(traverse);
                    return result;
                };

                const ids = collectIdsWithOrderDepartment(data, 2);
                setExplotionList(ids);
            } catch (error) {
                console.error(error);
            }
        };

        void fetchData();
    }, []);



    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);

            if(explotionList.length === 0) return;

            if (token) {
                try {
                    const decoded = jwtDecode(token);
                    setRole(decoded.role);
                    setUserId(decoded.UserId);
                } catch (error) {
                }
            }
            if (role !== null) {
                const requestBody = createRequestBody(pageSize, page);
                if (role === "USER") {
                    try {
                        const userNewCases = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCaseByRequesterIdNew`, requestBody);
                        setUserNewCaseCount(userNewCases.data.data.listCount);

                        const userCases = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCaseByRequesterId`, requestBody);
                        setUserCasesCurrent(userCases.data.data.listCount);

                        const userFinishedCases = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCaseByRequesterId`, {
                            ...requestBody,
                            statuses: [3, 10, 8]
                        });
                        setUserFinishedCases(userFinishedCases.data.data.listCount);

                    } catch (error) {
                    } finally {
                        setLoading(false);
                    }
                } else {
                    try {

                        const userData = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/User/GetOneUserByID?UserID=${userId}`)
                        setUserDepartment(userData.data.data.departmentId)
                        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCaseByActiveUserId`, {
                            ...requestBody,
                            viewed: false
                        });
                        const axalishetyobinebaCount = response.data.data.totalCount;
                        setAxaliShetyobinebaCount(axalishetyobinebaCount);


                        const response2 = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCaseByActiveUserId`, {
                            ...requestBody,
                            viewed: true
                        });
                        const chemiMimdinareGanacxadebiCount = response2.data.data.totalCount;
                        setChemiMimdinareGanacxadebiCount(chemiMimdinareGanacxadebiCount);

                        const response4 = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCase`, {
                            ...requestBody,
                            finished: true,
                            statuses: [3, 10, 8]
                        });
                        const dasrulebuliAdministraciuliWarmoebaCount = response4.data.data.listCount;
                        setDasrulebuliAdministraciuliWarmoebaCount(dasrulebuliAdministraciuliWarmoebaCount);

                        const response5 = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCaseOverdue`, requestBody);
                        const vadagadacilebuliCount = response5.data.data.totalCount;
                        setVadagadacilebuliCount(vadagadacilebuliCount);
                        if (role !== "HEADOFAGENCY") {
                            const inProgress = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCasesInProgress`, {
                                ...requestBody,
                                foltedByCaseNotificationStatusSentForVisage: true
                            });
                            const inProgressCount = inProgress.data.data.totalCount;
                            setMimdinareAdministraciuliWarmoebaCount(inProgressCount);
                        }
                        if (role !== "EXPERT") {
                            const lastUserIdCases = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCasePublic`, {
                                ...requestBody,
                                activeUserId: userId,
                                creteByExpert: false,
                                hideStatus: CaseStatus.CaseCreatedWithoutFiles.id

                            });
                            const lastUserIdCasesCount = lastUserIdCases.data.data.totalCount;
                            setLastActiveUserCases(lastUserIdCasesCount);
                        }
                        if (role === "HEADOFDEPARTMENT") {
                            const docsToSignResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCasePublic`, {
                                ...requestBody,
                                filterBySignStatus: 2
                            });
                            const docsToSignCases = docsToSignResponse.data.data.totalCount;
                            setDocsToSign(docsToSignCases);
                        }
                        if (role === "HEADOFDEPARTMENT") {
                            const docsWaitingSignResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCasePublic`, {
                                ...requestBody,
                                filterBySignStatus: 3
                            });
                            const docsWaitingSignCases = docsWaitingSignResponse.data.data.totalCount;
                            setWaitingToSign(docsWaitingSignCases);
                        }
                        if (role !== "USER") {
                            const inProgress = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCasePublic`, {
                                ...requestBody,
                                filterByIsSecretFile: true
                            });
                            const inProgressCount = inProgress.data.data.totalCount;
                            setSecretCases(inProgressCount);
                        }
                        const requestBodyForDeclination = {
                            pageSize: 0,
                            page: 0,
                            sort: [],
                            filter: [
                                {
                                    fieldName: "Status",
                                    numericValue: 4,
                                    dynamic: false,
                                    greaterDateTime: false
                                }
                            ],
                            pertmiTypeIdList: null
                        };


                        const declinedCases = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCase`, {
                            ...requestBodyForDeclination,
                            filterByCaseFileStatus: CaseStatus.Declined.id
                        });
                        const declinedCasesCount = declinedCases.data.data.listCount;
                        setDeclinedCasesCount(declinedCasesCount);

                        const response6 = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCase`, requestBody);
                        const istoriaCount = response6.data.data.listCount;
                        setIstoriaCount(istoriaCount);

                        const isTermOfPermissionAndConditionResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCase`,
                            {
                                ...requestBody,
                                isTermOfPermissionAndCondition: true,
                                filterByRole: false
                            });
                        const isTermOfPermissionAndCondition = isTermOfPermissionAndConditionResponse.data.data.listCount;
                        setIsTermOfPermissionAndConditionCount(isTermOfPermissionAndCondition);

                        const permitDocResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCasePublic`,
                            {
                                ...requestBody,
                                filterCaseByHasBuilidngDocumentFilterLogic: true,

                            });
                        const permitDoc = permitDocResponse.data.data.totalCount;
                        setPermitDocCount(permitDoc);

                        const expDocs = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCasePublic`,
                            {
                                ...requestBody,
                                filterByExplotionFile: true,
                                pertmiTypeIdList: explotionList
                            });
                        const expDoc = expDocs.data.data.totalCount;
                        setExpFile(expDoc);

                    } catch (error) {
                    } finally {
                        setLoading(false);
                    }
                }
            }
        };

        void fetchData();
    }, [page, pageSize, role, token, explotionList]);

    return (
        <div className="service-inner-component-dasha">
            {loading ? (
                <div className="homepage-table-loader">
                    <HiDocumentSearch style={{fontSize: 80, color: '#1A9AEE'}} className={"pulse-element"}/>
                    <h1>გთხოვთ დაელოდოთ...</h1>
                </div>
            ) : (
                <div>
                    {role === "USER" && (
                        <div>
                            <table className="homepage-table" style={{
                                width: isMobile ? "100%" : "80%",
                                margin: isMobile ? "auto" : "150px auto 0 auto"
                            }}>
                                <tbody>

                                <tr>
                                    <td style={{width: '5%'}}>
                                        <button className={"notification-button"}>
                                            <IoNotifications
                                                style={{fontSize: "35px", color: "#93A6CC"}}
                                            />
                                        </button>
                                    </td>
                                    <td>
                                        <Link className="box-link-completed"
                                              to="/dashboard/newcases"
                                        >
                                            <h2 className="box-title">ახალი შეტყობინებები</h2>
                                        </Link>
                                    </td>
                                    <td>
                                        <div className="alert-highliter">
                                            <strong className="notification_highliter">{userNewCaseCount}</strong>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td style={{width: '5%'}}>
                                        <button className={"notification-button"}>
                                            <TiFlowSwitch
                                                style={{fontSize: "35px", color: "#93A6CC"}}
                                            />
                                        </button>
                                    </td>
                                    <td>
                                        <Link className="box-link-completed" to="/dashboard/activecases"

                                        >
                                            <h2 className="box-title">ჩემი მიმდინარე განაცხადები</h2>
                                        </Link>

                                    </td>
                                    <td>
                                        <div className="alert-highliter">
                                            <strong
                                                className="notification_highliter">{userCasesCurrent}</strong>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '5%'}}>
                                        <button className={"notification-button"}>
                                            <MdCheckCircle
                                                style={{fontSize: "35px", color: "#93A6CC"}}
                                            />
                                        </button>
                                    </td>
                                    <td>
                                        <Link className="box-link-completed" to="/dashboard/myfinishedcases"

                                        >
                                            <h2 className="box-title">დასრულებული ადმნისტრაციული წარმოება</h2>
                                        </Link>

                                    </td>
                                    <td>
                                        <div className="alert-highliter">
                                            <strong
                                                className="notification_highliter">{userFinishedCases}</strong>
                                        </div>
                                    </td>
                                </tr>


                                </tbody>
                            </table>
                        </div>
                    )}
                    {role !== "USER" && role !== null && (
                        <div>
                            <table className="homepage-table" style={{width: "70%", margin: "50px auto 0 auto"}}>
                                <tbody>

                                <tr>
                                    <td style={{width: '5%'}}>
                                        <button className={"notification-button"}>
                                            <IoNotifications
                                                style={{fontSize: "35px", color: "#93A6CC"}}
                                            />
                                        </button>
                                    </td>
                                    <td>
                                        <Link className="box-link-completed"
                                              to="/dashboard/casenotifications"
                                        >
                                            <h2 className="box-title">ახალი შეტყობინებები</h2>
                                        </Link>
                                    </td>
                                    <td>
                                        <div className="alert-highliter">
                                            <strong className="notification_highliter">{axalishetyobinebaCount}</strong>
                                        </div>
                                    </td>
                                </tr>
                                {role !== "EXPERT" && role !== "USER" && (
                                    <tr>
                                        <td style={{width: '5%'}}>
                                            <button className={"notification-button"}>
                                                <IoTimer
                                                    style={{fontSize: "35px", color: "#93A6CC"}}
                                                />
                                            </button>
                                        </td>
                                        <td>
                                            <Link className="box-link-completed"
                                                  to="/dashboard/lastusercases"
                                            >
                                                <h2 className="box-title">შესასრულებელი</h2>
                                            </Link>
                                        </td>
                                        <td>
                                            <div className="alert-highliter">
                                                <strong
                                                    className="notification_highliter">{lastActiveUserCases}</strong>
                                            </div>
                                        </td>
                                    </tr>
                                )}


                                <tr>
                                    <td style={{width: '5%'}}>
                                        <button className={"notification-button"}>
                                            <TiFlowSwitch
                                                style={{fontSize: "35px", color: "#93A6CC"}}
                                            />
                                        </button>
                                    </td>
                                    <td>
                                        <Link className="box-link-completed"

                                              to="/dashboard/manageractivecases"
                                        >
                                            <h2 className="box-title">ჩემი მიმდინარე განაცხადები</h2>
                                        </Link>

                                    </td>
                                    <td>
                                        <div className="alert-highliter">
                                            <strong
                                                className="notification_highliter">{chemiMimdinareGanacxadebiCount}</strong>
                                        </div>
                                    </td>
                                </tr>
                                {(userDepartment === 2 && role === "HEADOFDEPARTMENT") && (

                                    <tr>
                                        <td style={{width: '5%'}}>
                                            <button className={"notification-button"}>
                                                <FaFileSignature
                                                    style={{fontSize: "35px", color: "#93A6CC"}}
                                                />
                                            </button>
                                        </td>

                                        <td>
                                            <Link className="box-link-completed" to="/dashboard/docsToSign">
                                                <h2 className="box-title">ხელმოსაწერი განაცხადები</h2>
                                            </Link>
                                        </td>
                                        <td>
                                            <div className="alert-highliter">
                                                <strong
                                                    className="notification_highliter">{docsToSign}</strong>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                {(userDepartment === 2 && role === "HEADOFDEPARTMENT" ) && (
                                    <tr>
                                        <td style={{width: '5%'}}>
                                            <button className={"notification-button"}>
                                                <VscFolderActive
                                                    style={{fontSize: "35px", color: "#93A6CC"}}
                                                />
                                            </button>
                                        </td>


                                        <td>
                                            <Link className="box-link-completed"

                                                  to="/dashboard/waitingToSign"
                                            >
                                                <h2 className="box-title">აქტიური ვიზა</h2>
                                            </Link>
                                        </td>
                                        <td>
                                            <div className="alert-highliter">
                                                <strong
                                                    className="notification_highliter">{waitingToSign}</strong>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                {role !== "HEADOFAGENCY" && (
                                    <tr>
                                        <td style={{width: '5%'}}>
                                            <button className={"notification-button"}>
                                                <TiFlowSwitch
                                                    style={{fontSize: "35px", color: "#93A6CC"}}
                                                />
                                            </button>
                                        </td>
                                        <td>
                                            <Link className="box-link-completed"
                                                  to="/dashboard/currentcases"
                                            >
                                                <h2 className="box-title">მიმდინარე ადმინისტრაციული წარმოება</h2>
                                            </Link>

                                        </td>
                                        <td>
                                            <div className="alert-highliter">
                                                <strong
                                                    className="notification_highliter">{mimdinareAdministraciuliWarmoebaCount}</strong>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                {/*{role !== "HEADOFAGENCY" && (*/}
                                {/*    <tr>*/}
                                {/*        <td style={{width: '5%'}}>*/}
                                {/*            <button className={"notification-button"}>*/}
                                {/*                <MdSdCardAlert*/}
                                {/*                    style={{fontSize: "35px", color: "#93A6CC"}}*/}
                                {/*                />*/}
                                {/*            </button>*/}
                                {/*        </td>*/}
                                {/*        <td>*/}
                                {/*            <Link className="box-link-completed"*/}
                                {/*                  to="/dashboard/mydeclinedcases"*/}
                                {/*            >*/}
                                {/*                <h2 className="box-title">ჩემი დახარვეზბული განაცხადები</h2>*/}
                                {/*            </Link>*/}

                                {/*        </td>*/}
                                {/*        <td>*/}
                                {/*            <div className="alert-highliter">*/}
                                {/*                <strong*/}
                                {/*                    className="notification_highliter">{myDeclinedCases}</strong>*/}
                                {/*            </div>*/}
                                {/*        </td>*/}
                                {/*    </tr>*/}
                                {/*)}*/}
                                <tr>
                                    <td style={{width: '5%'}}>
                                        <button className={"notification-button"}>
                                            <MdSdCardAlert
                                                style={{fontSize: "35px", color: "#93A6CC"}}
                                            />
                                        </button>
                                    </td>
                                    <td>
                                        <Link className="box-link-completed"
                                              to="/dashboard/declinedcases"
                                        >
                                            <h2 className="box-title"> დახარვეზბული განაცხადები</h2>
                                        </Link>

                                    </td>
                                    <td>
                                        <div className="alert-highliter">
                                            <strong
                                                className="notification_highliter">{declinedCasesCount}</strong>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '5%'}}>
                                        <button className={"notification-button"}>
                                            <VscGistSecret
                                                style={{fontSize: "35px", color: "#93A6CC"}}
                                            />
                                        </button>
                                    </td>
                                    <td>
                                        <Link className="box-link-completed"
                                              to="/dashboard/secretdocuments"
                                        >
                                            <h2 className="box-title">გასაიდუმლოებულია</h2>
                                        </Link>

                                    </td>
                                    <td>
                                        <div className="alert-highliter">
                                            <strong
                                                className="notification_highliter">{secretCases}</strong>
                                        </div>
                                    </td>
                                </tr>


                                {(userDepartment === 2 || role === "HEADOFAGENCY" || role === "DEPUTYHEADOFAGENCY") && (

                                    <tr>
                                        <td style={{width: '5%'}}>
                                            <button className={"notification-button"}>
                                                <RiPassExpiredLine
                                                    style={{fontSize: "35px", color: "#93A6CC"}}
                                                />
                                            </button>
                                        </td>


                                        <td>
                                            <Link className="box-link-completed"

                                                  to="/dashboard/expiring"
                                            >
                                                <h2 className="box-title">გასდის ნებართვის/პირობის ვადა</h2>
                                            </Link>
                                        </td>
                                        <td>
                                            <div className="alert-highliter">
                                                <strong
                                                    className="notification_highliter">{isTermOfPermissionAndConditionCount}</strong>
                                            </div>
                                        </td>
                                    </tr>
                                )}

                                {(userDepartment === 2 || role === "HEADOFAGENCY" || role === "DEPUTYHEADOFAGENCY") && (

                                    <tr>
                                        <td style={{width: '5%'}}>
                                            <button className={"notification-button"}>
                                                <IoHammerSharp
                                                    style={{fontSize: "35px", color: "#93A6CC"}}
                                                />
                                            </button>
                                        </td>


                                        <td>
                                            <Link className="box-link-completed"

                                                  to="/dashboard/permitdoc"
                                            >
                                                <h2 className="box-title">შესაქმნელია სანებართვო მოწმობა</h2>
                                            </Link>
                                        </td>
                                        <td>
                                            <div className="alert-highliter">
                                                <strong
                                                    className="notification_highliter">{permitDocCount}</strong>
                                            </div>
                                        </td>
                                    </tr>
                                )}

                                {(userDepartment === 1 || role === "HEADOFAGENCY" || role === "DEPUTYHEADOFAGENCY") && (

                                    <tr>
                                        <td style={{width: '5%'}}>
                                            <button className={"notification-button"}>
                                                <IoFlameSharp
                                                    style={{fontSize: "35px", color: "#93A6CC"}}
                                                />
                                            </button>
                                        </td>


                                        <td>
                                            <Link className="box-link-completed"

                                                  to="/dashboard/expfiles"
                                            >
                                                <h2 className="box-title">შესაქმნელია სანებართვო მოწმობა</h2>
                                            </Link>
                                        </td>
                                        <td>
                                            <div className="alert-highliter">
                                                <strong
                                                    className="notification_highliter">{expFile}</strong>
                                            </div>
                                        </td>
                                    </tr>
                                )}

                                <tr>
                                    <td style={{width: '5%'}}>
                                        <button className={"notification-button"}>
                                            <AiOutlineHourglass
                                                style={{fontSize: "35px", color: "#93A6CC"}}
                                            />
                                        </button>
                                    </td>
                                    <td>
                                        <Link className="box-link-completed"
                                              to="/dashboard/delayedcases"
                                        >
                                            <h2 className="box-title">ვადაგადაცილებული</h2>
                                        </Link>

                                    </td>
                                    <td className={"aaa"}>
                                        <div className="alert-highliter">
                                            <strong className="notification_highliter">{vadagadacilebuliCount}</strong>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '5%'}}>
                                        <button className={"notification-button"}>
                                            <FaHistory
                                                style={{fontSize: "35px", color: "#93A6CC"}}
                                            />
                                        </button>
                                    </td>
                                    <td>
                                        <Link className="box-link-completed"
                                              to="/dashboard/historycases"
                                        >
                                            <h2 className="box-title">ისტორია</h2>
                                        </Link>

                                    </td>
                                    <td>
                                        <div className="alert-highliter">
                                            <strong className="notification_highliter">{istoriaCount}</strong>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '5%'}}>
                                        <button className={"notification-button"}>
                                            <VscLayersActive
                                                style={{fontSize: "35px", color: "#93A6CC"}}
                                            />
                                        </button>
                                    </td>
                                    <td>
                                        <Link className="box-link-completed"

                                              to="/dashboard/finishedcases"
                                        >
                                            <h2 className="box-title">დასრულებული ადმინისტრაციული წარმოება</h2>
                                        </Link>

                                    </td>
                                    <td>
                                        <div className="alert-highliter">
                                            <strong
                                                className="notification_highliter">{dasrulebuliAdministraciuliWarmoebaCount}</strong>
                                        </div>
                                    </td>
                                </tr>

                                </tbody>
                            </table>
                        </div>
                    )}

                </div>
            )}


        </div>
    );
}

export default DashboardHomePage;
